import React, { FC, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useActivation } from "../../../../../lib/hooks/useActivation";
import { Transition } from "react-transition-group";
import { imagePath } from "../image/util";
import styled from "styled-components";
import { UserBubble } from "./DialogueBubble";
import { BubbleStyle, Icon, Row } from "./DialogueRow";

const UserRow: FC<{ image: string }> = ({ image, children, ...props }) => {
  const [ref, inView] = useInView({ threshold: 1 });
  const [inViewFirstly, activateInView] = useActivation(false);
  useEffect(() => {
    if (inView) activateInView();
  }, [inView]);
  return (
    <Transition in={inViewFirstly} timeout={400}>
      {(state) => (
        <Root ref={ref} $status={state} {...props}>
          <UserIcon src={imagePath(image)} loading="lazy" />
          <StyledUserBubble>{children}</StyledUserBubble>
        </Root>
      )}
    </Transition>
  );
};
export default UserRow;

const Root = styled(Row)`
  flex-direction: row;
`;
const UserIcon = styled(Icon)`
  border-radius: 50%;
`;
const StyledUserBubble = styled(UserBubble)`
  ${BubbleStyle};
  color: #1a1a1a;
`;
